export default __webpack_public_path__ + "static/media/priority-med-glyph-16-px.f034003c.svg";